module.exports = __webpack_public_path__ + "static/compare-movies-demo.c0a903b3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/compare-movies-demo.gif
// module id = 509
// module chunks = 268472206294114